export default {"src":"/_next/static/media/rightArrowIcon.de884b33.svg","height":16,"width":17};